import { FilePdfFilled } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontFamily: 'Helvetica',
      fontSize: 12
    },
    header: {
      marginBottom: 20,
      textAlign: 'center',
    },
    table: {
      display: 'table',
      width: '100%',
      marginBottom: 20,
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableCol: {
      width: '25%',
      border: '1px solid #000',
      padding: 5,
    },
    tableColLarge: {
      width: '50%',
      border: '1px solid #000',
      padding: 5,
    },
    boldText: {
      fontWeight: 'bold',
    },
    footer: {
      marginTop: 20,
      textAlign: 'center',
    },
  });

function PrintableInvoice({ order, isShow, setIsShow, invoiceSize = "A5" }) {
    const company = {
        name: 'Weda Arana',
        address: 'Kurunegala',
        contact: '0773333'
    };

    const client = {

    };
    
    const items = order?.orderItems?.map(item => {
        return {
            ...item,
            description: item.product.name,
            amount: (item.price * item.quantity).toFixed(2)
        };
    });
    const total = order?.total?.toFixed(2);


    return (
        <div>
            <Modal
                title={`${order.orderDate} | ${order.customerName} | ${order.orderTrackingNumber}`}
                centered
                maskClosable={false}
                open={isShow}
                onOk={() => setIsShow(false)}
                onCancel={() => setIsShow(false)}
                styles={{ body: { maxHeight: "600px", overflowY: "auto", paddingRight: 5 } }}
            >

                <PDFViewer width="100%" height="600">
                    <Document>
                        <Page size={invoiceSize} style={styles.page}>
                            {/* Header */}
                            <View style={styles.header}>
                                <Text style={styles.boldText}>{company.name}</Text>
                                <Text>{company.address}</Text>
                                <Text>{company.contact}</Text>
                            </View>

                            {/* Client Information */}
                            <View style={{ marginBottom: 10 }}>
                                <Text style={styles.boldText}>Bill To:</Text>
                                <Text>{client.name}</Text>
                                <Text>{client.address}</Text>
                                <Text>{client.contact}</Text>
                            </View>

                            {/* Invoice Table */}
                            <View style={styles.table}>
                                {/* Table Header */}
                                <View style={[styles.tableRow, { backgroundColor: '#f0f0f0' }]}>
                                    <Text style={styles.tableColLarge}>Description</Text>
                                    <Text style={styles.tableCol}>Quantity</Text>
                                    <Text style={styles.tableCol}>Price</Text>
                                    <Text style={styles.tableCol}>Amount</Text>
                                </View>
                                {/* Table Rows */}
                                {items?.map((item, index) => (
                                    <View key={index} style={styles.tableRow}>
                                        <Text style={styles.tableColLarge}>{item.description}</Text>
                                        <Text style={styles.tableCol}>{item.quantity}</Text>
                                        <Text style={styles.tableCol}>{item.price}</Text>
                                        <Text style={styles.tableCol}>{item.amount}</Text>
                                    </View>
                                ))}
                            </View>

                            {/* Total */}
                            <View style={{ textAlign: 'right', marginRight: 20 }}>
                                <Text style={styles.boldText}>Discount: {order?.totalDiscount}</Text>
                                <Text style={styles.boldText}>Total: {total}</Text>
                            </View>

                            {/* Footer */}
                            <View style={styles.footer}>
                                <Text>Thank you for your business!</Text>
                            </View>
                        </Page>
                    </Document>
                </PDFViewer>
                Internal
            </Modal>
        </div>
    )
}

export default PrintableInvoice